import React, { FC, memo } from 'react'

import Tooltip from 'rc-tooltip'

import HelpCircle from 'Icons/help-circle.svg'
import { Cart } from 'Types'

import HelpOverlay from './HelpOverlay'

type Props = Pick<
  Cart,
  | 'absorbShopAppFee'
  | 'customFees'
  | 'hstForAppFeeMoney'
  | 'hstForAppFeeMoneyFormatted'
  | 'hstForDeliveryCostMoney'
  | 'hstForDeliveryCostMoneyFormatted'
  | 'shopAppFeeMoney'
  | 'shopAppFeeMoneyFormatted'
  | 'totalTaxAndFeesMoneyFormatted'
  | 'totalTaxMoneyFormatted'
>

const TaxAndFees: FC<Props> = (props) => {
  const { totalTaxAndFeesMoneyFormatted, ...rest } = props
  return (
    <li>
      <span>Taxes & Fees</span>
      <Tooltip overlay={<HelpOverlay {...rest} />} placement="bottom" trigger="hover">
        <HelpCircle className="checkout-order__tooltip / ml-1 / sociavore-icon" />
      </Tooltip>
      <span className="ml-auto">{totalTaxAndFeesMoneyFormatted}</span>
    </li>
  )
}

export default memo(TaxAndFees)
